import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
// import { BsQuestionCircleFill } from 'react-icons/bs';
import { IoEyeOffOutline } from 'react-icons/io5';
import { IoEyeOutline } from 'react-icons/io5';

// svg
import logoTwo from '../Assets/compass-logo-2.svg';
import key from '../Assets/key.svg';
import personTwo from '../Assets/person-2.svg';
import exercise from '../Assets/exercise.svg';
import GoogleIcon from '../Assets/google_logo.svg';
import { ExamCompassContext } from '../Context/context';

type LoginPropsType = {
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
};

const Login: React.FC<LoginPropsType> = ({ showPassword, setShowPassword }) => {
  // From context
  const {
    loginInput,
    handleLoginInputs,
    loginUser,
    loading,
    loginNonFieldErr,
    successMessage,
  } = useContext(ExamCompassContext);

  return (
    <section className='w-full h-[100vh] relative bg-slate-200 overflow-hidden'>
      <div className='relative md:w-[50%] lg:w-[480px] h-[100%] bg-white pt-5 px-4 lg:px-16 pb-5 flex flex-col justify-between'>
        <div className='mb- absolute w-[80%] left-[50%] transform translate-x-[-50%] z-[5]'>
          <div className='flex items-center justify-between mb-4'>
            <div>
              <Link to={'/'}>
                <img className='w-[50px]' src={logoTwo} alt='Examcompass' />
              </Link>
            </div>
            <div>
              <p className='text-textColor text-[14px] lg:text-[14px] font-semibold text-center'>
                Don't have an account yet?
              </p>
              <Link to={'/register'}>
                <p className='text-darkGreen text-[14px] lg:text-[14px] font-semibold text-center cursor-pointer'>
                  Register here
                </p>
              </Link>
            </div>
          </div>
          <div className='w-[90%] mb-9'>
            <h2 className='text-[30px] text-darkGreen font-bold mb-4'>Login</h2>
            <p className='lg:text-[14px]'>
              Please input your information in the fields below.{' '}
            </p>
          </div>

          <form onSubmit={loginUser}>
            <span className='text-red-700'>
              {loginNonFieldErr}
              {loginNonFieldErr ===
                'Unable to log in with provided credentials.' &&
                'Incorrect username or password'}

              {loginNonFieldErr === 'Email not confirmed' &&
                'You email has not yet been verified. Please check your email to verify your account before login in.'}
            </span>
            <span className='text-green-500'>
              {successMessage && successMessage}
            </span>
            <p className='font-bold mb-1'>Account</p>
            <div className='mb-3'>
              <div className='border border-textColor bg-white flex items-center'>
                <div className='w-[14%] h-[40px] flex justify-center'>
                  <img className='w-[15px]' src={personTwo} alt='Emoji' />
                </div>
                <input
                  type='text'
                  placeholder='Username'
                  name='username'
                  value={loginInput?.username}
                  onChange={handleLoginInputs}
                  required
                  className='w-full h-[40px] text-[0.825em] pr-2 outline-none'
                />
              </div>

              <div className='border border-textColor bg-white border-t-0 flex items-center pr-2'>
                <div className='w-[14%] h-[40px] flex justify-center'>
                  <img className='w-[15px]' src={key} alt='Emoji' />
                </div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder='Password'
                  name='password'
                  value={loginInput?.password}
                  onChange={handleLoginInputs}
                  required
                  className='w-[86%] h-[40px] text-[0.825em] pr-2 outline-none'
                />
                {showPassword ? (
                  <IoEyeOutline
                    size={20}
                    onClick={() => setShowPassword(false)}
                    className='text-slate-500 cursor-pointer'
                  />
                ) : (
                  <IoEyeOffOutline
                    onClick={() => setShowPassword(true)}
                    size={20}
                    className='text-slate-500 cursor-pointer'
                  />
                )}
              </div>
            </div>

            <Link to={'/forgot-password'}>
              <p className='mb-8 text-darkGreen lg:text-[14px]'>
                Forgot your password?
              </p>
            </Link>

            <div className='flex items-center justify-between mb-4'>
              <div className='flex items-center gap-2'>
                <input
                  type='checkbox'
                  name='rememberMe'
                  checked={loginInput?.rememberMe}
                  onChange={handleLoginInputs}
                />
                <p className='lg:text-[14px]'>Remember Me</p>
              </div>
              <button
                type='submit'
                disabled={loading}
                className='bg-darkGreen text-white lg:text-[14px] w-[90px] h-[39px] lg:w-[102px] lg:h-[48px] rounded-[4px] cursor-pointer'
              >
                {loading ? 'Loading...' : 'Login'}
              </button>
            </div>

            <div className='flex items-center flex-col justify-around'>
              <div className='flex items-center justify-center gap-2'>
                <div className='w-[150px] h-[1px] bg-slate-300 ' />
                <p>OR</p>
                <div className='w-[150px] h-[1px] bg-slate-300 ' />
              </div>
              <Link
                to={`${process.env.REACT_APP_GOOGLE_SIGNIN_URL}client_id=${process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}`}
                className='flex mt-3 mb-4 gap-x-3 items-center justify-center transition-all duration-100 hover:bg-[#e0dfdf] bg-[#EEEEEE] rounded-md pt-3 pb-3 pr-8 pl-8
                '
              >
                <img src={GoogleIcon} className='w-4 h-4' alt='google Icon' />
                Continue with Google
              </Link>
            </div>
          </form>
        </div>
      </div>

      <img
        className='hidden md:block absolute z-[1] bottom-0 -right-[200px] md:-right-0
             w-full md:w-[500px] lg:w-[450px] xl:w-[850px] 2xl:w-auto'
        src={exercise}
        alt='Lady'
      />
    </section>
  );
};

export default Login;
